import $ from 'jquery';
import Handlebars from '../../handlebars_helpers';
import { allowInsecurePrototypeAccess } from '@handlebars/allow-prototype-access';
import _ from 'lodash';

export default class TyreRenderer {
  constructor(stateManager, apiClient, selectors) {
    this.stateManager = stateManager;
    this.apiClient = apiClient;
    this.selectors = selectors;
    this._initTemplates();
  }

  _initTemplates() {
    this.quantitySelectTemplate = null;
    this.specSelectTemplate = null;
    this.specSelectDropdownTemplate = null;
    this.specSelectOptionTemplate = null;
    this.tyreSelectTemplate = null;
    this.tyreCardsTemplate = null;
    this.tyresBasketTemplate = null;
    this.tyreRefineTemplate = null;
  }

  renderQuantitySelect(page, selections) {
    if (!this.quantitySelectTemplate) {
      this.quantitySelectTemplate = Handlebars.compile($('#tyres-quantity-select-template').html());
    }

    const markUp = this.quantitySelectTemplate(selections.quantities());
    page.html(markUp);

    page.find('.js-tyres-quantity-option').bindCheckBox({
      groupSelector: '.js-tyres-quantity',
      checkboxSelector: 'input[type=radio]',
      checkboxDescriptionStyle: { width: '100%', 'text-align': 'center', 'font-weight': 'bold' },
    });
    if (selections.hasQuantity()) $(this.selectors.quantitySelectSelector).prop('disabled', false);
  }

  renderSpecSelect(page, selections) {
    if (!this.specSelectTemplate) {
      this.specSelectTemplate = Handlebars.compile($('#tyres-spec-select-template').html());
    }

    const markUp = this.specSelectTemplate(selections);
    page.html(markUp);
    if (selections.hasFrontQuantity()) {
      this.renderSpecSelectDropdown('front', selections);
      if (selections.hasRearQuantity()) {
        $('.tyres-spec-select-front .tyres-position').html('Front &amp; Rear');
      } else {
        $('.same-as-front-checkbox').hide();
      }
    } else {
      $('.tyres-spec-select-front').hide();
      $('.same-as-front-checkbox').hide();
    }
    if (selections.hasRearQuantity()) {
      this.renderSpecSelectDropdown('rear', selections);
      if (!selections.hasFrontQuantity()) {
        $('.same-as-front-checkbox').hide();
      }
      if (selections.hasFrontQuantity() && selections.symmetric()) {
        $('.tyres-spec-select-rear').hide();
      }
    } else {
      $('.tyres-spec-select-rear').hide();
    }
    selections.specificationHasChanged(false);
    if (selections.isFullySpecified()) $(this.selectors.specSelectSelector).prop('disabled', false);
  }

  renderSpecSelectDropdown(position, selections) {
    if (!this.specSelectDropdownTemplate) {
      this.specSelectDropdownTemplate = Handlebars.compile($('#tyres-spec-select-dropdown-template').html());
    }

    const selector = $('.tyres-spec-' + position);
    const spinner = $(selector.find('.tyres-spec-select .loading-spinner')[0]);
    spinner.removeClass('hidden');

    const markUp = this.specSelectDropdownTemplate({ position: position });

    selector.append(markUp);
    this.apiClient.fetchTyreSpecs(position, selections, true, (data) => {
      if (data['widths'] && (!selections.specification(position).width || true))
        this.populateSpecSelectOptions(position, 'width', data['widths'], selections);
      if (data['profiles'] && (!selections.specification(position).profile || true))
        this.populateSpecSelectOptions(position, 'profile', data['profiles'], selections);
      if (data['rims'] && (!selections.specification(position).rim || true))
        this.populateSpecSelectOptions(position, 'rim', data['rims'], this.stateManager.getSelections());
      if (data['speed_ratings'] && (!selections.specification(position).speed || true))
        this.populateSpecSelectOptions(position, 'speed', data['speed_ratings'], this.stateManager.getSelections());
      spinner.addClass('hidden');
    });
  }

  populateSpecSelectOptions(position, key, data, selections) {
    if (!this.specSelectOptionTemplate) {
      this.specSelectOptionTemplate = Handlebars.compile($('#tyres-spec-select-option-template').html());
    }

    const values = data.map(function (value) {
      const selected = selections.specification(position).get(key) === value;
      return { value: value, selected: selected };
    });

    const markUp = this.specSelectOptionTemplate(values);
    $('#tyres-spec-' + position + '-' + key + ' option')
      .slice(1)
      .remove();
    $('#tyres-spec-' + position + '-' + key)
      .append(markUp)
      .prop('disabled', false);
    $('#tyres-spec-' + position + '-' + key)
      .closest('.tyres-spec-select')
      .removeClass('select-hidden');

    if (position === 'front' && selections.symmetric()) {
      $('#tyres-spec-rear-' + key).append(markUp);
    }
  }

  clearSpecSelectOptions(position, key) {
    $('#tyres-spec-' + position + '-' + key + ' option')
      .slice(1)
      .remove();
    this.stateManager.getSelections().specification(position).set(key, null);
  }

  renderTyreSelect(page, tyres, unmatchedSpecifications) {
    if (!this.tyreSelectTemplate) {
      this.tyreSelectTemplate = Handlebars.compile($('#tyres-tyre-select-template').html());
    }

    const tyreList = {
      selections: this.stateManager.getSelections(),
      unmatchedSpecifications: _.uniq(unmatchedSpecifications.map((spec) => spec.toString())),
      tyres: tyres,
    };

    const markUp = this.tyreSelectTemplate(tyreList);
    page.html(markUp);

    this.renderTyreCards(page.find('.js-tyres-tyre-cards'), tyres);
  }

  renderTyreCards(container, tyres) {
    if (!this.tyreCardsTemplate) {
      this.tyreCardsTemplate = Handlebars.compile($('#tyres-tyre-cards-template').html());
    }

    const markUp = this.tyreCardsTemplate({ tyres: tyres, selections: this.stateManager.getSelections() });
    container.html(markUp);

    $(this.selectors.tyreSelectSelector + '.added').trigger('tyreAdded');
  }

  renderTyresBasket(container, tyres) {
    if (!this.tyresBasketTemplate) {
      this.tyresBasketTemplate = Handlebars.compile($('#tyres-basket-template').html());
    }

    const markUp = this.tyresBasketTemplate({ tyres: tyres, selections: this.stateManager.getSelections() });
    container.html(markUp);
  }

  renderTyreRefine(selector, applyRefinementsCallback) {
    if (!this.tyreRefineTemplate) {
      this.tyreRefineTemplate = allowInsecurePrototypeAccess(Handlebars).compile($('#tyres-tyre-refine-template').html());
    }
    const refinements = this.stateManager.getRefinements();

    const markUp = this.tyreRefineTemplate(refinements.filterGroups());
    selector.html(markUp);
    refinements.filterGroups().forEach((filterGroup) => {
      filterGroup.filters().forEach((filter) => {
        $('#' + filter.toString()).on('click', function () {
          if (this.checked) {
            filter.activate();
          } else {
            filter.deactivate();
          }
          applyRefinementsCallback();
        });
      });
    });
  }

  withSpinner(container, callback) {
    const spinner = container.find('.loading-spinner');
    container.addClass('opaque');
    spinner.removeClass('hidden');
    callback();
    container.removeClass('opaque');
    spinner.addClass('hidden');
  }

  scrollToTarget(target, offset = 0) {
    if (target.length) {
      const top = target.offset().top + offset;
      $('html, body').animate({ scrollTop: top }, 1000);
      return false;
    }
  }
}
